import { API, UserGiftDetailVO } from "@akc/biz-api";

/**
 * @description 满赠活动详情
 * @link https://yapi.akcops.com/project/1799/interface/api/427784
 * @author 金言
 **/
export const queryGiftDetail = async (actId: string) => {
  return API.post<UserGiftDetailVO>({
    hostID: "h5shop",
    path: "/api/mshop/mshop-aggr-prod/outer/gift/detail",
    body: {
      actId: actId,
    },
  });
};
